// hooks/useTranslateKey.js
import { useContext, useCallback } from "react";
import { LangContext } from "./langugeContext";
import { translations } from "./translation";

export function useTranslateKey() {
  const { lang } = useContext(LangContext);

  const tKey = useCallback(
    (key) => {
      const dict = translations[lang] || {};
      return dict[key] ?? key;
    },
    [lang]
  );

  return tKey;
}
